import { css } from 'lit';
import { roundButtonOnDarkStyles } from './round-button--onDark.styles';

export const style = css`
  :host {
    display: inline-block;
    --button__border--focus: var(--_button__border--focus , var(--sbkRoundButtonBorderOnLightFocus));

    --round-button__color: var(--_round-button__color, var(--sbkRoundButtonBgColorOnDarkEnabled));
    --round-button__color--active: var(--_round-button__color--active, var(--sbkRoundButtonBgColorOnDarkEnabled));
    --round-button__color--hover: var(--_round-button__color--hover , var(--sbkRoundButtonFgColorOnLightDefault));
    --round-button__color--focus: var(--_round-button__color--focus , var(--sbkRoundButtonBgColorOnDarkEnabled));
    --round-button__color--disabled: var(--_round-button__color--disabled , var(--sbkRoundButtonFgColorOnLightDisabled));
    --round-button__color--error: var(--_round-button__color--error, var(--sbkRoundButtonFgColorOnDarkDefault));
    --round-button-icon-only__color: var(--_round-button-icon-only__color, var(--sbkRoundButtonBgColorOnLightEnabled));

    --round-button__bg: var(--_round-button__bg , var(--sbkRoundButtonBgColorOnLightEnabled));
    --round-button__bg--active: var(--_round-button__bg--active , var(--sbkRoundButtonBgColorOnLightActive));
    --round-button__bg--hover: var(--_round-button__bg--hover , var(--sbkRoundButtonBgColorOnLightHover));
    --round-button__bg--focus: var(--_round-button__bg--focus , var(--sbkRoundButtonBgColorOnLightFocus));
    --round-button__bg--disabled: var(--_round-button__bg--disabled , var(--sbkRoundButtonBgColorOnLightDisabled));
    --round-button__bg--error: var(--_round-button__bg--error, var(--sbkRoundButtonBgColorOnLightError));
    --round-button-icon-only__bg: var(--_round-button-icon-only__bg, var(--sbkRoundButtonBgColorOnLightEnabledTransparent));

    --round-button__border-color: var(--_round-button__border-color, var(--sbkRoundButtonBorderOnLightMarked));
    --round-button__border-color--active: var(--_round-button__border-color--active, var(--sbkButtonBorderOnLightActive));
    --round-button__border-color--hover: var(--_round-button__border-color--hover, var(--sbkButtonBorderOnLightHover));
    --round-button__border-color--focus: var(--_round-button__border-color--focus, var(--sbkButtonBorderOnLightFocus));
    --round-button__border-color--disabled: var(--_secondary-button__border-color--disabled, var(--sbkButtonBorderOnLightDisabled));
    --round-button__border-color--error: var(--_secondary-button__border-color--error, var(--sbkButtonBorderOnLightDisabled));
}
  :host([hidden]) {
      display: none;
  }

  * {
    box-sizing: border-box;
  }

:host([alternativestyling]) {
  ${roundButtonOnDarkStyles}
}

.round-button {
  font: var(--sbkRoundButtonLabel);
  border: 2px solid transparent;
  border-radius: var(--sbkRoundButtonBorderRadiusBorderRadiusDefault);
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: 2px solid transparent;
  outline-offset: var(--sbkRoundButtonBorderRadiusBorderGapFocus);
  background-color: var(--round-button__bg);
  color: var(--round-button__color);
  text-decoration: none;
}

  @media (hover: hover) and (pointer: fine) {
  .round-button:hover:not([disabled]) {
    background-color: var(--round-button__bg--hover);
    border: var(--round-button__border-color--hover);
    color: var(--round-button__color--hover);
  }
}



  .round-button__icon-slot::slotted(div) {
    filter: brightness(0) saturate(100%) invert(16%) sepia(19%) saturate(7500%) hue-rotate(189deg) brightness(97%) contrast(104%);
  }

  @media (hover: hover) and (pointer: fine) {
    .round-button:hover .round-button__icon-slot::slotted(div) {
      filter: brightness(0) saturate(100%) invert(100%) sepia(15%) saturate(5522%) hue-rotate(209deg) brightness(120%) contrast(107%);
    }
  }

  .round-button:focus-visible:not(:active) {
    outline: var(--button__border--focus);
    background-color: var(--round-button__bg--focus);
    border: 2px solid transparent;
    color: var(--round-button__color--focus);
  }

  .round-button-extra-small {
    padding: var(--sbkRoundButtonSpacing3xs);
    height: 20px;//var(--sbkRoundButtonSizingMaxHeightExtraSmallIconOnly);
    width: 20px; //var(--sbkRoundButtonSizingMaxHeightExtraSmallIconOnly);
    &.round-button-icon-only {
      height: 20px; //var(--sbkRoundButtonSizingMaxHeightExtraSmallIconOnly);
      width: 20px; //var(--sbkRoundButtonSizingMaxHeightExtraSmallIconOnly);
    }
  }

  .round-button-small {
    padding: var(--sbkRoundButtonSpacing3xs);
    height: var(--sbkRoundButtonSizingMaxHeightSmall);
    width: var(--sbkRoundButtonSizingMaxHeightSmall);
    &.round-button-icon-only {
      height: var(--sbkRoundButtonSizingMaxHeightSmallIconOnly);
      width: var(--sbkRoundButtonSizingMaxHeightSmallIconOnly);
    }
  }

  .round-button-medium {
    padding: var(--sbkRoundButtonSpacing3xs);
    height: var(--sbkRoundButtonSizingMaxHeightMedium);
    width: var(--sbkRoundButtonSizingMaxHeightMedium);
    &.round-button-icon-only {
      height: var(--sbkRoundButtonSizingMaxHeightMediumIconOnly);
      width: var(--sbkRoundButtonSizingMaxHeightMediumIconOnly);
    }
  }

  .round-button-large {
    padding: var(--sbkRoundButtonSpacing2xs);
    height: var(--sbkRoundButtonSizingMaxHeightLarge);
    width: var(--sbkRoundButtonSizingMaxHeightLarge);
    &.round-button-icon-only {
      height: var(--sbkRoundButtonSizingMaxHeightLargeIconOnly);
      width: var(--sbkRoundButtonSizingMaxHeightLargeIconOnly);
    }
  }

  /* todo: Adjust roundbutton sizing tokens */
  .round-button-extra-large {
    padding: var(--sbkRoundButtonSpacing2xs);
    height: var(--sbkRoundButtonSizingMaxHeightLargeIconOnly);
    width: var(--sbkRoundButtonSizingMaxHeightLargeIconOnly);
  }

  .round-button-text, .round-button-icon-only {
    background-color: var(--round-button-icon-only__bg);
        color: var(--round-button-icon-only__color);
  }

  .round-button[disabled] {
      background-color: var(--round-button__bg--disabled);
      color: var(--round-button__color--disabled);
      cursor: not-allowed;
  }

    .round-button--error {
        background-color: var(--round-button__bg--error);
        color: var(--round-button__color--error);
    }

    .round-button--active, .round-button:active, .round-button:hover:active {
        background-color: var(--round-button__bg--active);
        border: var(--round-button__border-color--active);
        color: var(--round-button__color--active);
    }


`;
